module.exports = __webpack_public_path__ + "img/course_004.6c6b6d2.webp";